module.exports = __webpack_public_path__ + "static/media/LineVerticalPurpleColor.dd20f590.svg";